<template>
  <div class="product-details-content-register-submodule-customization">
    <div class="my-6">
      <step-title
        title="Personalização"
        description="Defina como será a cara do submódulo para seus alunos."
        icon="fa-solid fa-pen-ruler"
        fa
      />
    </div>

    <div class="pt-5">
      <span>Capa horizontal</span>
    </div>
    <div class="row pb-6">
      <input-image
        id="imagem-horizontal"
        v-model="form.header"
        title="Capa horizontal"
        description="Esta imagem será exibida no topo. ATENÇÃO: caso não seja adicionada uma imagem horizontal, por padrão, a mesma imagem vertical será exibida no topo do submódulo, na horizontal."
        dimensions="1440x280px"
        class="pt-5 col-lg-5"
      />
      <header-mockup :image="form.header" class="pt-lg-5 d-none d-lg-block" />
    </div>
    <hr />

    <div class="pt-5">
      <span>Capa versão mobile</span>
    </div>
    <div class="row pb-6">
      <input-image
        v-model="form.cover_mobile"
        id="image-mobile-cover"
        title="Cartaz vertical"
        description="Esta imagem será exibida no topo e na tela inicial."
        class="pt-5 col-lg-5"
        dimensions="560x740px"
      />
      <image-cover-mockup
        mobile
        :image="form.cover_mobile"
        class="pt-lg-5 d-none d-lg-block"
      />
    </div>
    <hr />

    <div class="pt-5">
      <span>Cartaz vertical</span>
    </div>
    <div class="row pb-6">
      <input-image
        id="imagem-vertical"
        v-model="form.picture"
        title="Cartaz vertical"
        description="Esta imagem será exibida na tela inicial."
        dimensions="560x800px"
        class="pt-5 col-lg-5"
      />
      <picture-mockup :image="form.picture" class="pt-lg-5 d-none d-lg-block" />
    </div>
  </div>
</template>
<script>
import HeaderMockup from "@/components/product/member-area/module/HeaderMockup";
import PictureMockup from "@/components/product/member-area/module/PictureMockup";
import ImageCoverMockup from "@/components/product/member-area/setup/ImageCoverMockup.vue";

export default {
  components: {
    HeaderMockup,
    PictureMockup,
    ImageCoverMockup
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.product-details-content-register-module-customization {
  span {
    color: #2b2733;
    font-size: 14px;
  }
  .icon-angle-left {
    font-size: 24px;
    margin-bottom: 3px;
  }
}
</style>
